import { apiService } from './api';

export interface AnalyticsMemberRow {
  member: { id:number; fullName:string; memberNumber:string; membershipType:string; status:string };
  last:string|null; due:string|null; overdue:number; state:string; rejoins:number; delays:number[]; payments:number; revenue:number;
}
interface Month { month:string; revenue:number; payments:number; payers:number; }
export interface PaymentAnalyticsReport {
  personalTraining:TrainingComparison;
  unusualMembers:UnusualMember[];
asOf:string; graceDays:number; paymentCount:number; payingMembers:number; excluded:number; activeMembers:number; unmatchedPaymentsExcluded:number;
  revenuePaymentCount:number; revenuePayingMembers:number; revenueExcluded:number;
  trend:Month[]; rows:AnalyticsMemberRow[]; overdue:AnalyticsMemberRow[]; lapsed:AnalyticsMemberRow[]; known:AnalyticsMemberRow[];
  lateIntervals:number[]; intervals:number[]; average:number|null; baseline:Month[]; allRevenue:number;
  plans:{plan:string;members:number;payers:number;lapsed:number;revenue:number}[];
  retention:{month:string;prior:number;retained:number;rate:number|null}[];
  methods:{method:string;revenue:number;count:number;share:number|null}[];
  unmatched:number; returning:AnalyticsMemberRow[]; noPayment:AnalyticsMemberRow[];
  overdueShare:number|null; lateShare:number|null; averageLateDays:number|null; rejoinEvents:number;
  conservative:number|null; upside:number|null; threeMonth:number|null;
  recommendations:{title:string;description:string}[];
  followUp:AnalyticsMemberRow[]; followUpMonths:number;
}
export interface TrainingComparison {
  segments:{label:string;payments:number;payers:number;revenue:number;revenueShare:number|null}[];
  cohorts:{label:string;payers:number;payments:number;revenue:number;averagePayment:number|null;revenuePerPayer:number|null;repeatPayers:number;repeatShare:number|null;averagePaymentGapDays:number|null}[];
  trend:{month:string;regularRevenue:number;trainingRevenue:number;bundledRevenue:number}[];
  overlapPayers:number;
  recommendations:{title:string;description:string}[];
}
export interface UnusualMember {
  member:AnalyticsMemberRow['member']; lastFlagDate:string;
  flags:{type:string;date:string;detail:string;action:string}[];
}
export interface PaymentAiSnapshot {
  generatedOn:string; asOf:string; graceDays:number; source:string; scope:string;
  summary:string;
  evidence:{label:string;value:string;note:string}[];
  findings:{title:string;observation:string;interpretation:string}[];
  actions:{priority:string;title:string;action:string;measure:string}[];
  limitations:string[];
}
export async function getPaymentAiSnapshot():Promise<PaymentAiSnapshot> {
  const response=await apiService.get<PaymentAiSnapshot>('/api/payments/analytics/ai-snapshot');
  if (!response.success || !response.data) throw new Error(response.message || 'Unable to load AI snapshot');
  return response.data;
}
export async function getPaymentAnalytics(asOf:string,graceDays:number,followUpMonths=0):Promise<PaymentAnalyticsReport> {
  const params=new URLSearchParams({asOf,graceDays:String(graceDays),followUpMonths:String(followUpMonths)});
  const response=await apiService.get<PaymentAnalyticsReport>(`/api/payments/analytics?${params}`);
  if (!response.success || !response.data) throw new Error(response.message || 'Unable to generate payment analytics');
  return response.data;
}
export const money = (value:number) => 'LKR ' + Math.round(value).toLocaleString('en-LK');
export async function getPaymentFollowUp(asOf:string,graceDays:number,followUpMonths:number):Promise<AnalyticsMemberRow[]> {
  const params=new URLSearchParams({asOf,graceDays:String(graceDays),followUpMonths:String(followUpMonths)});
  const response=await apiService.get<AnalyticsMemberRow[]>(`/api/payments/analytics/follow-up?${params}`);
  if(!response.success||!response.data)throw new Error(response.message||'Unable to load follow-up list');
  return response.data;
}
export interface PaymentReminderDraft {
  memberId:number; fullName:string; memberNumber:string; phone:string; message:string; enabled:boolean;
}
export async function getPaymentReminderDraft(memberId:number):Promise<PaymentReminderDraft> {
  const response=await apiService.get<PaymentReminderDraft>(`/api/payments/analytics/members/${memberId}/reminder`);
  if(!response.success||!response.data)throw new Error(response.message||'Unable to prepare reminder');
  return response.data;
}
export async function sendPaymentReminder(memberId:number,message:string,phone:string):Promise<string> {
  const response=await apiService.postOnce(`/api/payments/analytics/members/${memberId}/reminder`,{message,phone});
  if(!response.success)throw new Error(response.message||'Unable to confirm reminder submission');
  return response.message||'Reminder submitted to the SMS gateway. Delivery is not yet confirmed.';
}
